export const PROBLEM_BASE_URL = '/problem';
